import ContainedIcon from '@/components/ContainedIcon';
import OpenAIIconBase from '@/components/Icons/OpenAiIcon';
import { SharedEndpointModelFamily } from '@/graphql';

import {
  mapIconSizeToSize,
  mapModelFamilyToIconColor,
  mapModelFamilyToIconContainerColor,
} from '../utils';
import { SharedEndpointIconProps, SharedEndpointIconSize } from './types';

function OpenAIIcon({ size }: SharedEndpointIconProps) {
  const [containerSize, iconSize] = mapIconSizeToSize(size);

  return (
    <ContainedIcon
      size={containerSize}
      color={mapModelFamilyToIconContainerColor(SharedEndpointModelFamily.Openai)}
      borderRadius={size === SharedEndpointIconSize.XSMALL ? 6 : 8}
    >
      <OpenAIIconBase
        sx={{
          width: iconSize,
          height: iconSize,
          color: mapModelFamilyToIconColor(SharedEndpointModelFamily.Openai),
        }}
      />
    </ContainedIcon>
  );
}

export default OpenAIIcon;
